import { render, staticRenderFns } from "./ArchieveTabOld.vue?vue&type=template&id=2ae21834&scoped=true"
import script from "./ArchieveTabOld.vue?vue&type=script&lang=js"
export * from "./ArchieveTabOld.vue?vue&type=script&lang=js"
import style0 from "./ArchieveTabOld.vue?vue&type=style&index=0&id=2ae21834&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae21834",
  null
  
)

export default component.exports